import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import CustomChip from '../../../Components/CustomChip';

const UmangUtsavBanner = ({ location, receivers_count, venue, date }) => {
    return (
        <Box
            sx={{
                position: 'relative',
                borderRadius: 2,
                overflow: 'hidden',
            }}
        >
            {/* Gradient background with blur — matches Figma BG layer */}
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '120%',
                height: '120%',
                backdropFilter: 'blur(45px)',
                background: 'linear-gradient(122.84deg, #B9DDE5 0.84%, #FFC066 42.82%, #B9DDE5 91.4%)',
                zIndex: 0,
            }} />

            {/* Location chip — sits on top of both layers */}
            <CustomChip
                label={location}
                size="small"
                selected={true}
                sx={{ position: 'absolute', top: 8, right: 8, zIndex: 2 }}
            />

            {/* Content */}
            <Box
                sx={{
                    position: 'relative',
                    zIndex: 1,
                    borderRadius: 2,
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                }}
            >
                {/* Header row: logo + title/subtitle */}
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start', pr: { xs: 10, md: 5 } }}>
                    <Box
                        component="img"
                        src='https://d2djimvzddgguw.cloudfront.net/humbee-my-network/uu-logo.png'
                        alt="Umang Utsav Logo"
                        sx={{
                            width: 64,
                            height: 38,
                            borderRadius: '4px',
                            objectFit: 'cover',
                            flexShrink: 0,
                        }}
                    />
                    <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                        <Typography variant="h2" sx={{ color: '#333' }}>
                            Umang Utsav
                        </Typography>
                        <Typography variant="p1" noWrap sx={{ color: '#666' }}>
                            Respect • Recognition • Reward
                        </Typography>
                    </Box>
                </Box>

                <Divider sx={{ borderColor: '#E0E0E0' }} />

                {/* Info rows */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                    <Typography variant="h3" sx={{ color: '#333' }}>
                        {receivers_count} Influencer{receivers_count !== '1' ? 's' : ''} invited
                    </Typography>

                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                        <Typography variant="h3" sx={{ color: '#333', width: 50, flexShrink: 0 }}>
                            Venue:
                        </Typography>
                        <Typography variant="body1" sx={{ color: '#333', flex: 1 }}>
                            {venue}
                        </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                        <Typography variant="h3" sx={{ color: '#333', width: 50, flexShrink: 0 }}>
                            Date:
                        </Typography>
                        <Typography variant="body1" sx={{ color: '#333', flex: 1 }}>
                            {date}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default UmangUtsavBanner;
